module.exports = __webpack_public_path__ + "static/img/car-grey.b15a9042.svg";